import { render, staticRenderFns } from "./WatermarkComponent.vue?vue&type=template&id=7004f318&"
import script from "./WatermarkComponent.vue?vue&type=script&lang=js&"
export * from "./WatermarkComponent.vue?vue&type=script&lang=js&"
import style0 from "./WatermarkComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports